<template>
  <path
    d="M14.79 13.0002H13V4.00024C13 3.45024 12.55 3.00024 12 3.00024C11.45 3.00024 11 3.45024 11 4.00024V13.0002H9.21C8.76 13.0002 8.54 13.5402 8.86 13.8502L11.65 16.6402C11.85 16.8402 12.16 16.8402 12.36 16.6402L15.15 13.8502C15.46 13.5402 15.24 13.0002 14.79 13.0002ZM4 20.0002C4 20.5502 4.45 21.0002 5 21.0002H19C19.55 21.0002 20 20.5502 20 20.0002C20 19.4502 19.55 19.0002 19 19.0002H5C4.45 19.0002 4 19.4502 4 20.0002Z"
  />
</template>
